import { NavLink, useParams } from 'react-router-dom';
import { LayoutDashboard, ClipboardList, Plus, Users, Settings, Building2, ParkingSquare } from 'lucide-react';
import { cn } from '@/lib/utils/cn';
import { useAuth } from '@/hooks/useAuth';

export function MobileNav() {
  const { isPlatformAdmin, isClientAdmin, isCompanyAdmin, canCreateInspections, canReviewInspections, canManageUsers } = useAuth();

  const { tenantSlug } = useParams<{ tenantSlug?: string }>();
  const prefix = tenantSlug ? `/${tenantSlug}` : '';
  const adminContext = isPlatformAdmin() && !tenantSlug;

  const items = [
    { label: 'Painel', to: adminContext ? '/admin/tenants' : `${prefix}/dashboard`, icon: LayoutDashboard, show: true },
    { label: 'Vistorias', to: `${prefix}/inspections`, icon: ClipboardList, show: canReviewInspections() && !adminContext },
    { label: 'Empresas', to: adminContext ? '/admin/tenants' : `${prefix}/companies`, icon: Building2, show: isPlatformAdmin() || isClientAdmin() },
    { label: 'Pátios', to: `${prefix}/parking-lots`, icon: ParkingSquare, show: (isPlatformAdmin() || isClientAdmin() || isCompanyAdmin()) && !adminContext },
    { label: 'Usuários', to: adminContext ? '/admin/users' : `${prefix}/users`, icon: Users, show: canManageUsers() },
    { label: 'Vistoriar', to: `${prefix}/inspect/new`, icon: Plus, show: canCreateInspections() && !adminContext },
    { label: 'Config.', to: adminContext ? '/admin/settings' : `${prefix}/settings`, icon: Settings, show: true },
  ].filter((i) => i.show);

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-slate-200 bg-white lg:hidden safe-area-bottom">
      <div className="flex items-center">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            className={({ isActive }) =>
              cn(
                'flex flex-1 flex-col items-center gap-0.5 py-2.5 px-2 text-[10px] font-medium transition-colors',
                isActive ? 'text-primary-600' : 'text-slate-500 hover:text-slate-700',
              )
            }
          >
            {({ isActive }) => (
              <>
                <div
                  className={cn(
                    'flex h-7 w-7 items-center justify-center rounded-lg transition-colors',
                    isActive ? 'bg-primary-50' : '',
                    item.icon === Plus && 'bg-primary-600 text-white rounded-full',
                  )}
                >
                  <item.icon
                    className={cn('h-4 w-4', item.icon === Plus && 'text-white')}
                  />
                </div>
                <span>{item.label}</span>
              </>
            )}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
